import { Link } from "react-router-dom";
import { allCategories, getCategoryCount } from "@/utils/software";
import { toneIconWrap } from "@/utils/ui";

export default function CategoryGrid() {
  return (
    <section className="container-page pt-10">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {allCategories.map((cat) => (
          <Link
            key={cat.id}
            to={`/category/${cat.id}`}
            className="card-surface group flex items-start gap-3 p-4 transition-colors hover:border-primary-400"
          >
            <span
              className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-lg text-2xl ${
                toneIconWrap[cat.tone] ?? toneIconWrap.primary
              }`}
            >
              <i className={cat.icon} />
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex items-center justify-between gap-2">
                <h3 className="font-heading text-base font-bold text-foreground-900 transition-colors group-hover:text-primary-700">
                  {cat.name}
                </h3>
                <span className="shrink-0 text-xs text-foreground-500">
                  {getCategoryCount(cat.id)} 款
                </span>
              </div>
              <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                {cat.desc}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}